export enum AuthErrorCode {
  NotAllowedException = 'NotAllowedException',
  NotAuthorizedException = 'NotAuthorizedException',
  UserDisabledException = 'UserDisabledException',
  UserNotFoundException = 'UserNotFoundException',
  Unknown = 'Unknown',
}
